var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 181,
    viewBox: "0 0 182 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.503 0C176.857 0 178.075 0.37035 179.158 1.11105C181.391 2.72712 182.304 4.88188 181.898 7.57534L155.913 162.718C155.574 164.671 154.492 166.186 152.665 167.263C151.717 167.802 150.668 168.071 149.518 168.071C148.773 168.071 147.961 167.903 147.082 167.566L101.1 148.881L76.5351 178.677C75.3171 180.226 73.6592 181 71.5614 181C70.6816 181 69.9373 180.865 69.3282 180.596C68.0425 180.125 67.0105 179.333 66.2323 178.222C65.4541 177.111 65.065 175.882 65.065 174.536V139.285L152.766 32.3214L44.2563 125.751L4.16148 109.388C1.65767 108.445 0.304256 106.593 0.101244 103.833C-0.0340969 101.139 1.04863 99.1527 3.34943 97.8733L172.255 0.90904C173.27 0.303013 174.353 0 175.503 0Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 181,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paperPlane.629e8c95011940bd760f1fd456d7ca49.svg";
export { ForwardRef as ReactComponent };